import React, { useState, useEffect, useRef } from 'react'
import Api from '../../../../_helpers/Api'
import Skeleton from 'react-loading-skeleton'
import { trans } from '../../../../_providers/Translation'
import GroupedBarChart from '../../../partials/GroupedBarChart'
import { CHART_PALETTE } from '../../../partials/chartTheme'
import { Button } from '@mui/material'
import CompactFilterLayout from '@/components/partials/CompactFilterLayout'
import DateRange from '@/components/partials/DateRange'
import filterImage from '@/assets/img/icons/filter.svg'



const INITIAL_FILTERS = {
    date_from: null,
    date_to: null,
}

function Finances() {
    const STATUSES = [
        { name: trans('random.income'), ...CHART_PALETTE[2] },
        { name: trans('random.expense'), ...CHART_PALETTE[0] },
    ]

    const [state, setState] = useState({
        loading: true,
        labels: [],
        incomes: [],
        expenses: [],
        currency: '',
    })
    const [filters, setFilters] = useState(INITIAL_FILTERS)

    const compactFilterLayoutRef = useRef(null)
    const fetchDebounceRef = useRef(null)

    useEffect(() => {
        clearTimeout(fetchDebounceRef.current)
        fetchDebounceRef.current = setTimeout(() => {
            loadData()
        }, 300)
        return () => clearTimeout(fetchDebounceRef.current)
    }, [filters])

    const loadData = () => {
        setState(prev => ({ ...prev, loading: true }))
        Api.get(`accounts/profit?date_from=${filters.date_from || ''}&date_to=${filters.date_to || ''}`)
            .then(res => {
                const dates = res.data.dates || []
                setState(prev => ({
                    ...prev,
                    labels: dates.map(d => d.label),
                    incomes: dates.map(d => d.incomes),
                    expenses: dates.map(d => d.expenses),
                    currency: res.data.currency || '',
                }))
            })
            .finally(() => setState(prev => ({ ...prev, loading: false })))
    }

    function handleFilterChange(name, value) {
        setFilters(prev => ({ ...prev, [name]: value }))
    }

    function getAppliedFiltersCount() {
        return filters.date_from || filters.date_to ? 1 : 0
    }

    const formatCurrency = (value) => `${Number(value).toFixed(2)} ${state.currency}`

    const series = [
        {
            name: STATUSES[0].name,
            color1: STATUSES[0].color1,
            color2: STATUSES[0].color2,
            data: state.incomes,
            valueFormatter: formatCurrency,
        },
        {
            name: STATUSES[1].name,
            color1: STATUSES[1].color1,
            color2: STATUSES[1].color2,
            data: state.expenses,
            valueFormatter: formatCurrency,
        },
    ]

    return (
        <div className="incomes-expenses-chart">
            <div className='head'>
                <h3>{trans(`random.${filters.date_from || filters.date_to ? 'finances' : 'financeDifference'}`)}</h3>
                <div className='right'>
                    <ul>
                        {STATUSES.map(status => (
                            <li key={status.name}>
                                <span style={{
                                    background: `linear-gradient(to bottom, ${status.color1}, ${status.color2})`
                                }} />
                                {status.name}
                            </li>
                        ))}
                    </ul>
                    <Button onClick={(e) => {
                        compactFilterLayoutRef.current.open(e)
                    }}>
                        <img src={filterImage} alt="Filter" />
                        {getAppliedFiltersCount() ?
                            <i>{getAppliedFiltersCount()}</i>
                            : <></>}
                    </Button>
                    <CompactFilterLayout
                        ref={compactFilterLayoutRef}
                        appliedFiltersCount={getAppliedFiltersCount()}
                        onClearClick={() => setFilters(INITIAL_FILTERS)}
                    >
                        <div className='row'>
                            <div className='col'>
                                <DateRange
                                    startDate={filters.date_from || ''}
                                    endDate={filters.date_to || ''}
                                    onStartDateChange={(date) => handleFilterChange('date_from', date)}
                                    onEndDateChange={(date) => handleFilterChange('date_to', date)}
                                />
                            </div>
                        </div>
                    </CompactFilterLayout>
                </div>
            </div>
            <hr />
            {state.loading || !state.labels.length
                ? <Skeleton height={360} count={1} />
                : <GroupedBarChart labels={state.labels} series={series} barWidth={20} roundedBottom />
            }
        </div>
    )
}

export default Finances
